import EventEmitter from 'eventemitter3'

const globalEmitter = new EventEmitter()
//default error handler
globalEmitter.on('error', (err) => {
    console.error(err)
})

export default globalEmitter
